/*
  v-focus
 */
export default {
  inserted(el) {
    el.focus();
  },
};
